import React from 'react';
import { ArrowRight } from 'lucide-react';
import bfbBackground from '../assets/bfb-background-new.png';
import bfbLogo from '../assets/bfb-method-logo.png';

const BFBMethodSection = () => {
  const buildingBlocks = [
    { title: 'Build Belief', description: 'Build belief in yourself and your vision' },
    { title: 'Build Confidence', description: 'Build confidence in your voice and presence' },
    { title: 'Build Systems', description: 'Build systems that support you instead of draining you' },
    { title: 'Build Income', description: 'Build income without sacrificing your peace' }
  ];

  return (
    <section id="bfb-section" className="py-32 relative overflow-hidden" style={{ backgroundColor: '#f8f6f3' }}>
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url(${bfbBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      />
      
      <div className="container mx-auto px-8 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-20">
            <p className="text-xs tracking-[0.3em] mb-8 font-light" style={{ color: '#8b7355' }}>
              MY SIGNATURE METHOD
            </p>
            
            {/* BFB Method Logo */}
            <div className="flex justify-center mb-12">
              <img 
                src={bfbLogo} 
                alt="The BFB Method Logo" 
                className="w-full max-w-sm md:max-w-md h-auto object-contain"
              />
            </div>
          </div>

          {/* Core Message */}
          <div className="text-center mb-20">
            <h3 
              className="text-2xl md:text-3xl font-light mb-6"
              style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
            >
              This method is designed to help you
            </h3>
            <p 
              className="text-4xl md:text-5xl lg:text-6xl font-light tracking-wide"
              style={{ color: '#1a1a1a' }}
            >
              BUILD WITHOUT BREAKING.
            </p>
          </div>
          
          {/* Empathy Text */}
          <div className="max-w-3xl mx-auto text-center mb-20">
            <p className="text-base font-light leading-relaxed mb-6" style={{ color: '#666' }}>
              I get it. Building something new can feel overwhelming — especially if you're starting over after a breakup, or stepping away from the 9–5 for the first time.
            </p>
            <p className="text-base font-light leading-relaxed" style={{ color: '#666' }}>
              I know because I've been there. I've built, lost, rebuilt, and built again — more than once. That's exactly why this method exists: <span style={{ color: '#1a1a1a' }}>to help you move forward with clarity, confidence, and support instead of burnout.</span>
            </p>
          </div>

          {/* Building Blocks */}
          <div className="grid md:grid-cols-2 gap-6 mb-16">
            {buildingBlocks.map((block, index) => (
              <div 
                key={index}
                className="p-8 border transition-all duration-300 hover:border-[#8b7355]"
                style={{ borderColor: 'rgba(0,0,0,0.1)', backgroundColor: 'rgba(255,255,255,0.8)' }}
              >
                <h4 className="text-lg font-light mb-2" style={{ color: '#1a1a1a' }}>
                  {block.title}
                </h4>
                <p className="text-sm font-light" style={{ color: '#666' }}>
                  {block.description}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center">
            <a 
              href="#services"
              className="inline-flex items-center gap-2 border text-xs tracking-[0.15em] px-10 py-4 transition-all duration-300 hover:bg-[#1a1a1a] hover:text-white"
              style={{ borderColor: '#1a1a1a', color: '#1a1a1a' }}
            >
              EXPLORE MY PROGRAMS
              <ArrowRight size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BFBMethodSection;
